import { Button, Heading, Icon, IconButton, Input, Select, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useState } from "react";


import { FaArrowLeft, FaArrowRight, FaColumns, FaSync } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { RiFilterOffFill } from "react-icons/ri";

export default function EmailInbox() {
    const [invs] = useState([
        {
            inboxId: 67009,
            emailTo: 'hamza@app.entry-bot.com',
            envelopTo: 'hadi@app.entry-bot.com',
            receivedFor: 'NULL',
            deliveredTo: 'inam@app.entry-bot.com',
            emailFrom: "someukclient@ukfirm.com",
            subject: "Hey Bro! Can you convert these invoices for me!",
            emailDate: "2022-04-03"
        },
        {
            inboxId: 67009,
            emailTo: 'hamza@app.entry-bot.com',
            envelopTo: 'hadi@app.entry-bot.com',
            receivedFor: 'NULL',
            deliveredTo: 'inam@app.entry-bot.com',
            emailFrom: "someukclient@ukfirm.com",
            subject: "Hey Bro! Can you convert these invoices for me!",
            emailDate: "2022-04-03"
        },
        {
            inboxId: 67009,
            emailTo: 'hamza@app.entry-bot.com',
            envelopTo: 'hadi@app.entry-bot.com',
            receivedFor: 'NULL',
            deliveredTo: 'inam@app.entry-bot.com',
            emailFrom: "someukclient@ukfirm.com",
            subject: "Hey Bro! Can you convert these invoices for me!",
            emailDate: "2022-04-03"
        },
        {
            inboxId: 67009,
            emailTo: 'hamza@app.entry-bot.com',
            envelopTo: 'hadi@app.entry-bot.com',
            receivedFor: 'NULL',
            deliveredTo: 'inam@app.entry-bot.com',
            emailFrom: "someukclient@ukfirm.com",
            subject: "Hey Bro! Can you convert these invoices for me!",
            emailDate: "2022-04-03"
        },
        {
            inboxId: 67009,
            emailTo: 'hamza@app.entry-bot.com',
            envelopTo: 'hadi@app.entry-bot.com',
            receivedFor: 'NULL',
            deliveredTo: 'inam@app.entry-bot.com',
            emailFrom: "someukclient@ukfirm.com",
            subject: "Hey Bro! Can you convert these invoices for me!",
            emailDate: "2022-04-03"
        },
        {
            inboxId: 67009,
            emailTo: 'hamza@app.entry-bot.com',
            envelopTo: 'hadi@app.entry-bot.com',
            receivedFor: 'NULL',
            deliveredTo: 'inam@app.entry-bot.com',
            emailFrom: "someukclient@ukfirm.com",
            subject: "Hey Bro! Can you convert these invoices for me!",
            emailDate: "2022-04-03"
        },
        {
            inboxId: 67009,
            emailTo: 'hamza@app.entry-bot.com',
            envelopTo: 'hadi@app.entry-bot.com',
            receivedFor: 'NULL',
            deliveredTo: 'inam@app.entry-bot.com',
            emailFrom: "someukclient@ukfirm.com",
            subject: "Hey Bro! Can you convert these invoices for me!",
            emailDate: "2022-04-03"
        },
        {
            inboxId: 67009,
            emailTo: 'hamza@app.entry-bot.com',
            envelopTo: 'hadi@app.entry-bot.com',
            receivedFor: 'NULL',
            deliveredTo: 'inam@app.entry-bot.com',
            emailFrom: "someukclient@ukfirm.com",
            subject: "Hey Bro! Can you convert these invoices for me!",
            emailDate: "2022-04-03"
        },
        {
            inboxId: 67009,
            emailTo: 'hamza@app.entry-bot.com',
            envelopTo: 'hadi@app.entry-bot.com',
            receivedFor: 'NULL',
            deliveredTo: 'inam@app.entry-bot.com',
            emailFrom: "someukclient@ukfirm.com",
            subject: "Hey Bro! Can you convert these invoices for me!",
            emailDate: "2022-04-03"
        },
        {
            inboxId: 67009,
            emailTo: 'hamza@app.entry-bot.com',
            envelopTo: 'hadi@app.entry-bot.com',
            receivedFor: 'NULL',
            deliveredTo: 'inam@app.entry-bot.com',
            emailFrom: "someukclient@ukfirm.com",
            subject: "Hey Bro! Can you convert these invoices for me!",
            emailDate: "2022-04-03"
        }
    ]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={MdEmail}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Email Inbox</Heading>
                            <Text fontSize={'sm'}>All expense invoices, receipts & refund documents.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack
                    spacing={4}
                    justify={'end'}
                    direction={'row'}
                    align={{ lg: 'flex-start', xl: 'flex-end' }}
                >
                    <Stack direction={'row'} spacing={2}>
                        <Input
                            type="date"
                            size={'md'}
                        />
                    </Stack>

                    <Button
                        size={'md'}
                        leftIcon={<FaSync />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Refresh
                    </Button>

                    <Button
                        size={'md'}
                        leftIcon={<FaColumns />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Columns
                    </Button>

                    <Button
                        size={'md'}
                        leftIcon={<RiFilterOffFill />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Filter
                    </Button>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    isNumeric
                                    color={"white"}
                                >
                                    Inbox ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Email To
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Envelop To
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Received For
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Delivered To
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Email Form
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Subject
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Email DateTime
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                invs.map((inv, i) => (
                                    <Tr>
                                        <Td>{inv.inboxId}</Td>
                                        <Td>{inv.emailTo}</Td>
                                        <Td>{inv.envelopTo}</Td>
                                        <Td>{inv.receivedFor}</Td>
                                        <Td>{inv.deliveredTo}</Td>
                                        <Td>{inv.emailFrom}</Td>
                                        <Td>{inv.subject}</Td>
                                        <Td>{inv.emailDate}</Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}